import { z } from "zod";

import { Task, TaskSet } from "@/core/types";

import { RouteFormValues, routeToFormValues, RouteFormValuesSchema } from "../RouteForm/formValues";

export type TaskFormValues = {
  route: RouteFormValues | null;
  routeUuid?: string;
  notes: string | null;
  allocatedDuration: number | null;
  name: string | null;
  assignees: string[];
};

export function taskToFormValues(task?: Task, taskSet?: TaskSet): TaskFormValues {
  const route = routeToFormValues(task?.route ?? undefined);
  if (taskSet?.competition && !route.competition) {
    route.competition = taskSet?.competition;
  }

  return {
    route,
    notes: task?.notes || null,
    allocatedDuration: task?.allocatedDuration || null,
    name: task?.name || null,
    assignees: task?.assignees?.map((a) => a.uuid) || [],
  };
}

export const TaskFormValuesSchema = z.object({
  route: RouteFormValuesSchema.nullable(),
  routeUuid: z.string().optional(),
  notes: z.string().nullable(),
  allocatedDuration: z.number().nullable(),
  name: z.string().nullable(),
  assignees: z.array(z.string().uuid()),
});
